import { Stack } from '@mui/material';
import * as React from 'react';
import { BreadcrumbFromContext } from 'v2/components/Breadcrumb/Breadcrumb';
import BreadcrumbProvider from 'v2/components/Breadcrumb/BreadcrumbProvider';

const Page: React.FC<React.PropsWithChildren> = ({ children }) => (
  <BreadcrumbProvider>
    <Stack
      spacing="32px"
      sx={{
        padding: {
          xs: '16px 16px',
          md: '48px 32px'
        },
        maxWidth: '1800px',
        margin: '0 auto',
        width: '100%',
        flexGrow: 1
      }}
    >
      <BreadcrumbFromContext />
      {children}
    </Stack>
  </BreadcrumbProvider>
);

export default Page;
